
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { BoxStatusType, Connection } from '@/types';
import EditConnectionAuthDialog from '@/components/connections/EditConnectionAuthDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

moment.locale('it');

@Component({
  components: {
    EditConnectionAuthDialog,
  },
})
export default class ConnectionAuth extends Mixins(UtilsMixin) {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    // L'editing è disabilitato per chi non ha i permessi di modifica degli allegati
    // di tipo titoloAutorizzativo
    return this.loading
      || (!this.hasPermission('attachments.titoloAutorizzativo.add')
      && !this.hasPermission('attachments.titoloAutorizzativo.delete'));
  }

  get titoloAutorizzativoTaskStatus(): string {
    return this.connection?.titoloAutorizzativoTaskStatus || '';
  }

  get tTooltipColor(): string {
    return this.connection ? this.tooltipColor(this.connection?.titoloAutorizzativoStatus) : '';
  }

  get tChipOutlined(): boolean {
    return this.connection ? this.chipOutlined(this.connection?.titoloAutorizzativoStatus) : false;
  }

  get tChipColor(): string {
    if (this.loading) return 'grey';
    return this.connection ? this.chipColor(this.connection?.titoloAutorizzativoStatus) : '';
  }

  get hasNotes(): boolean {
    return this.connection?.hasTitoloAutorizzativoNotes === true;
  }

  get tTooltipText(): string {
    return this.tooltipText('Titolo autorizzativo', this.connection?.titoloAutorizzativoStatus);
  }

  get columnClass(): string {
    if (this.titoloAutorizzativoTaskStatus === 'completed') return 'green';
    if (this.titoloAutorizzativoTaskStatus === 'error') return 'red';
    if (this.connection?.titoloAutorizzativoStatus === 'done') return 'green';
    return '';
  }

  chipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey lighten-2';

      case 'done':
        return 'statusDone';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  chipOutlined(value: BoxStatusType | null): boolean {
    switch (value) {
      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  tooltipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  tooltipText(prefix: string, value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return `${prefix} (assente)`;

      case 'na':
        return `${prefix} (non applicabile)`;

      case 'waiting':
        return `${prefix} (in attesa di terzi)`;

      default:
        break;
    }
    return prefix;
  }

  // Azioni

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.isDisabled || this.isConnectionLoading || this.currentConnection !== null) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}
